const { assign, escapeRegExp, truncate } = require('lodash')
const invalidChars = '\n\t\r:\\/?*[]'
const escapedInvalidChars = escapeRegExp(invalidChars)
const regex = new RegExp(`[${escapedInvalidChars}]`, 'gm')

const checkNotString = (value, paramName) => {
  if (typeof value !== 'string') {
    throw new TypeError(`Invalid ${paramName} type.  Expecting a string.  Actual type: ${typeof value}`)
  }
}

const checkInvalidChars = (str, paramName) => {
  if (regex.test(str)) {
    throw new SyntaxError(`${paramName} contains forbidden characters for excel sheet name.  Invalid characters are: ${invalidChars} Given ${paramName}: ${str}`)
  }
}

const fixSheetName = (sheetName, options) => {
  options = assign({
    empty: '<empty>',
    replacement: ' ',
    omission: '...'
  }, options)

  checkNotString(sheetName, 'sheetName')
  checkNotString(options.empty, 'options.empty')
  checkNotString(options.replacement, 'options.replacement')
  checkNotString(options.omission, 'options.omission')

  checkInvalidChars(options.empty, 'options.empty')
  checkInvalidChars(options.replacement, 'options.replacement')
  checkInvalidChars(options.omission, 'options.omission')

  if (!sheetName) {
    return options.empty
  }

  sheetName = sheetName.replace(regex, options.replacement)
  sheetName = truncate(sheetName, {
    length: 31,
    omission: options.omission
  })
  return sheetName
}
module.exports = fixSheetName
module.exports.invalidChars = invalidChars
